import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Link from 'src/components/Link'
import { useDispatch } from 'src/redux/hooks'
import { hasOptionalAnalytics } from 'src/functions/analyticsConfig'
import type { MenuPageBuilder } from 'src/shared/dbTypes/menuPageBuilder'
import shopInfos from 'template/infos'
import Fussnoten from './Fussnoten'

const legalLinks = [
  { href: '/zahlung-und-versand', label: 'Zahlung & Versand' },
  { href: '/agb', label: 'AGB' },
  { href: '/widerrufsbelehrung', label: 'Widerrufsrecht' },
  { href: '/widerruf', label: 'Vertrag widerrufen' },
  { href: '/datenschutzerklaerung', label: 'Datenschutz' },
  { href: '/impressum', label: 'Impressum' },
]

export default function CheckoutFooter({ footer }: { footer?: MenuPageBuilder['footer'] }) {
  const dispatch = useDispatch()
  const surface = footer?.surfaceColor || footer?.backgroundColor || 'var(--page-builder-surface, #fff4e9)'
  const text = footer?.textColor || 'var(--page-builder-text, #102d59)'
  const muted = footer?.mutedTextColor || 'var(--page-builder-muted, #465570)'

  return <Box data-checkout-footer='compact' sx={{
    backgroundColor: surface, color: text, borderTop: '1px solid rgba(16, 45, 89, .12)', py: { xs: 2, md: 3 },
    '& a, & button': { color: 'inherit', textUnderlineOffset: '3px' },
    '& a:focus-visible, & button:focus-visible, & summary:focus-visible': { outline: '2px solid currentColor', outlineOffset: '3px' },
  }}>
    <Container maxWidth='lg'>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '4px 18px', fontSize: '.875rem' }}>
        <strong>Fragen zu deiner Bestellung?</strong>
        <a href={`mailto:${shopInfos.email}`}>{shopInfos.email}</a>
        <Link href='/kontakt'>Kontaktformular</Link>
      </Box>
      <Box component='nav' aria-label='Rechtliche Informationen' sx={{
        display: 'flex', flexWrap: 'wrap', gap: '0 20px', mt: 1, fontSize: '.8rem', color: muted,
        '& a, & button': { display: 'inline-flex', alignItems: 'center', minHeight: 40 },
        '& button': { border: 0, p: 0, background: 'none', font: 'inherit', textDecoration: 'underline', cursor: 'pointer' },
      }}>
        {legalLinks.map(link => <Link key={link.href} href={link.href}>{link.label}</Link>)}
        {hasOptionalAnalytics && <button type='button' onClick={() => dispatch({ type: 'showCookieBanner' })}>Cookie-Einstellungen</button>}
      </Box>
    </Container>
    <Box component='details' sx={{ mt: 1, '& .MuiTypography-root': { fontSize: '.75rem', lineHeight: 1.5 } }}>
      <Box component='summary' sx={{
        maxWidth: 1200, mx: 'auto', px: { xs: 2, sm: 3 }, py: 1,
        cursor: 'pointer', fontSize: '.8rem', color: muted, textUnderlineOffset: '3px',
      }}>Preis- und Lieferhinweise</Box>
      <Fussnoten
        backgroundColor={surface}
        textColor={muted}
        linkColor={text}
        primaryHtml={footer?.footnotesPrimaryHtml}
        secondaryHtml={footer?.footnotesSecondaryHtml}
        paddingTop={12}
        paddingBottom={0}
      />
    </Box>
  </Box>
}
